<template>
   <div class="row productListing" :class=" ( this.isFiltering ? 'loader' : '' ) ">
       <b-col
               cols="12"
               sm="6"
               md="4"
               v-for='(product, index, key) in productsSlave'
               :key="'col_'+index"
               v-show="( ( products.length == 0 || products.includes(index) ) && !$root.emptyFilters)"
       >
           <product-box
                   :product='product'
                   v-if="!product.event"
           ></product-box>
           <event-box
                   v-else
                   :index="1"
                   :event="product"
           >
           </event-box>
       </b-col>
       <b-col
            cols="12"
            md="12"
            v-show="productsSlave.length == 0"
            :key="'col_nothing'"
       >
           <h3 class="no-products">No products matching your criteria have been found.</h3>
       </b-col>
       <b-col
            cols="12"
            md="12"
            :key="'col_landing'"
            v-show=" ( productsSlave.length > 0 && $root.emptyFilters ) "
            class="product-listing-landing"
       >
            <b-row>
                <b-col
                    cols="12"
                >
                    <h3 class="font-24 eagle mb-3">Best Sellers</h3>
                    <div class="slider">
                        <swiper
                            :options="{
                                direction: 'horizontal',
                                slidesPerView: 3,
                                spaceBetween: 10,
                                loop: true,
                                navigation: {
                                    nextEl: '.swiper-next',
                                    prevEl: '.swiper-prev'
                                },
                                breakpoints: {
                                    991: {
                                        slidesPerView: 1
                                    }
                                }
                            }"
                        >
                            <swiper-slide v-for='product in this.bestsellers'>
                                <product-box
                                        :product='product'
                                ></product-box>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-next"></div>
                    </div>
                </b-col>
                <b-col
                    cols="12"
                >
                    <h3 class="font-24 eagle mb-3" v-if="this.specialoffers">Special Offers</h3>
                    <div class="slider">
                        <swiper
                                :options="{
                                direction: 'horizontal',
                                slidesPerView: 3,
                                spaceBetween: 10,
                                loop: ( this.specialoffers && this.specialoffers.length > 3 ? true : false ),
                                navigation: {
                                    nextEl: '.swiper-next-1',
                                    prevEl: '.swiper-prev-1'
                                },
                                breakpoints: {
                                    991: {
                                        slidesPerView: 1
                                    }
                                }
                            }"
                        >
                            <swiper-slide v-for='product in this.specialoffers'>
                                <product-box
                                        :product='product'
                                ></product-box>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-next-1"></div>
                    </div>
                </b-col>
                <b-col
                    cols="12"
                >
                    <h3 class="font-24 eagle mb-3" v-if="this.gifts">Gifts</h3>
                    <div class="slider">
                        <swiper
                                :options="{
                                direction: 'horizontal',
                                slidesPerView: 3,
                                spaceBetween: 10,
                                loop: ( this.gifts && this.gifts.length > 3 ? true : false ),
                                navigation: {
                                    nextEl: '.swiper-next-2',
                                    prevEl: '.swiper-prev-2'
                                },
                                breakpoints: {
                                    991: {
                                        slidesPerView: 1
                                    }
                                }
                            }"
                        >
                            <swiper-slide v-for='product in this.gifts'>
                                <product-box
                                        :product='product'
                                ></product-box>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-next-2"></div>
                    </div>
                </b-col>
            </b-row>
       </b-col>
   </div>
</template>

<script>
    export default {
        name: "ProductListing",
        props: {
            productsarray: Array,
            gifts: Array,
            bestsellers: Array,
            specialoffers: Array
        },
        data: function() {
            return {
                products: [0,1,2,3,4,5,6,7,8,9,10,11],
                page: 1,
                perPage: 12,
                productsSlave: [],
                productsMaster: [],
                searchQ: '',
                filterValues: [],
                sortParam: '',
                priceRange: [],
                isFiltering: false
            }
        },
        mounted() {
            this.productsSlave = this.productsMaster = this.productsarray;
            // Initialy sort products by name ascending
            this.productsSlave.sort(function(a,b) {
                let titlea = a['title'].toLowerCase();
                let titleb = b['title'].toLowerCase();

                if ( titlea.includes('voucher') ) return -1
                if ( titleb.includes('voucher') ) return 1

                let salesa = parseFloat(a['total_sales']);
                let salesb = parseFloat(b['total_sales']);
                if(salesa > salesb) return -1;
                if(salesa < salesb) return 1;
            });

            // Handle change on the ammount of items displayed per page
            this.$root.$on('productsChangePerPage', per_page => {
                this.perPage = parseInt(per_page);
                this.recalculatePages();
            });

            // Handle page change
            this.$root.$on('productsChangePage', page => {
                this.page = parseInt(page[0]);
                this.recalculatePages();
            });

            // Sort products
            this.$root.$on('productsSortBy', parameter => {
                this.sortParam = parameter;
            });

            // Search products
            this.$root.$on('productSearch', query => {
                if ( query.length > 0 ) {
                    this.$root.emptyFilters = false
                } else {
                    this.$root.emptyFilters = true
                    for ( var filter in this.filterValues ) { // For each attribute
                        if (this.filterValues[filter].length == 0)
                            continue
                        else
                            this.$root.emptyFilters = false;
                    }
                }
                this.searchQ = query;
            });

            // Filter products
            this.$root.$on('productFilter', filterValues => {
                // this.isFiltering = true
                this.filterValues = filterValues;
                this.$root.emptyFilters = true;
                for ( var filter in this.filterValues ) { // For each attribute
                    if ( !this.filterValues[filter] || this.filterValues[filter].length == 0)
                        continue
                    else
                        this.$root.emptyFilters = false;
                }
                this.filterProducts();
            });

            // Set products price range
            this.$root.$on('productsPriceRange', range => {
                this.$root.emptyFilters = false
                this.priceRange = range;
                this.filterProducts();
            });
        },
        methods: {
            // Set the products to be displayed on the current page
            // based on the perPage argument and page number
            recalculatePages: function() {
                this.products = Array(this.perPage).fill(this.perPage*(this.page-1)).map((x,y) => x + y);
            },
            sortProducts: function() {

                let parameter = this.sortParam;
                this.productsSlave.sort(function(a,b) {
                    let titlea = a['title'].toLowerCase();
                    let titleb = b['title'].toLowerCase();

                    if ( titlea.includes('voucher') ) return -1
                    if ( titleb.includes('voucher') ) return 1

                    let pricea = parseFloat(typeof a['attributes']['_price'] == 'object' ? a['attributes']['_price'][0] : a['attributes']['_price']);
                    let priceb = parseFloat(typeof b['attributes']['_price'] == 'object' ? b['attributes']['_price'][0] : b['attributes']['_price']);
                    let salesa = parseFloat(a['total_sales']);
                    let salesb = parseFloat(b['total_sales']);

                    switch (parameter) {
                        case 'name_asc':
                            if(titlea < titleb) return -1;
                            if(titlea > titleb) return 1;
                            break;

                        case 'name_desc':
                            if(titlea > titleb) return -1;
                            if(titlea < titleb) return 1;
                            break;

                        case 'price_asc':
                            if(pricea < priceb) return -1;
                            if(pricea > priceb) return 1;
                            break;

                        case 'price_desc':
                            if(pricea > priceb) return -1;
                            if(pricea < priceb) return 1;
                            break;

                        case 'bestsellers':
                            if(salesa > salesb) return -1;
                            if(salesa < salesb) return 1;
                            break;

                        default:
                            return 0;
                            break;
                    }
                });

            },
            filterProducts: function() {
                var tmp = this.productsMaster

                    // Search products by serach input
                if ( this.searchQ.length > 0 )
                    tmp = tmp.filter( item => {
                        if ( item.title.toLowerCase().includes( this.searchQ.toLowerCase() ) )
                            return true;
                        return false;
                    } )

                var regions = []

                if ( Object.keys(this.filterValues).length > 0 )
                    tmp = tmp.filter( item => {
                        var r = Object.entries(this.filterValues).every( function(attribute) {
                            if ( !attribute[1] || attribute[1].length == 0 ) return true
                            if ( typeof item.attributes[attribute[0]] != 'undefined' )
                                return item.attributes[attribute[0]].some( function(value) {
                                    return attribute[1].includes(value)
                                } )
                            else
                                return ( item.categories.some( function(cat) {
                                    return attribute[1].includes(cat)
                                } ) )
                        } )

                        if ( r )
                            if ( this.filterValues['country'] &&
                                this.filterValues['country'].length > 0 &&
                                ( !this.filterValues['region'] || this.filterValues['region'].length == 0 ) &&
                                item.attributes['region']
                            )
                                regions.push( ...item.attributes['region'] )

                        return r
                    } )

                regions = regions.filter( (value, index, self) => {
                    return self.indexOf(value) === index
                } )

                if (  this.filterValues['country'] && this.filterValues['country'].length > 0 && ( !this.filterValues['region'] || this.filterValues['region'].length == 0 ) ) {
                    this.$root.$emit('constrainRegions', regions.sort());
                } else if ( this.filterValues['country'] && this.filterValues['country'].length > 0 && this.filterValues['region'].length > 0 ) {
                    // just do nothing T_T
                } else {
                    this.$root.$emit('constrainRegions', []);
                }

                // FIlter by price
                if ( this.priceRange.length > 0 )
                    tmp = tmp.filter( item => {
                        if ( parseFloat( item.attributes['_price'] ) >= parseFloat( this.priceRange[0] ) &&
                            parseFloat( item.attributes['_price'] ) <= parseFloat(this.priceRange[1]) )
                            return true;
                        return false;
                    } )

                // Move serached products to the main varible
                this.productsSlave = tmp
                // Sort products if need be
                if(this.sortParam.length > 0) this.sortProducts()

                // Update product count
                this.$root.$emit('updateProductCount', tmp.length)

                this.isFiltering = false
            }
        },
        watch: {
            searchQ: function(val) {
                this.filterProducts();
            },
            sortParam: function(val) {
                this.filterProducts();
            }
        }
    }
</script>